type Task = () => void

const INTERACTION_EVENTS = ['pointerdown', 'keydown', 'touchstart', 'scroll']
const IDLE_TIMEOUT_MS = 3000

let isIdle = false
const pending: Task[] = []

const flush = () => {
	if (isIdle) return
	isIdle = true
	INTERACTION_EVENTS.forEach((event) => {
		window.removeEventListener(event, flush)
	})
	pending.splice(0).forEach((task) => {
		task()
	})
}

const scheduleAfterLoad = () => {
	if ('requestIdleCallback' in window) {
		window.requestIdleCallback(flush, { timeout: IDLE_TIMEOUT_MS })
	} else {
		setTimeout(flush, 1500)
	}
}

if (typeof window !== 'undefined') {
	if (document.readyState === 'complete') {
		scheduleAfterLoad()
	} else {
		window.addEventListener('load', scheduleAfterLoad, { once: true })
	}

	// A visitor who interacts early gets the deferred work immediately
	INTERACTION_EVENTS.forEach((event) => {
		window.addEventListener(event, flush, { once: true, passive: true })
	})
}

/**
 * Runs non-critical work (analytics, session replay) after the page has
 * loaded and the main thread is idle, or on the first user interaction,
 * whichever comes first. Keeps third-party code off the first render.
 */
export const whenPageIdle = (task: Task) => {
	if (isIdle) {
		task()
	} else {
		pending.push(task)
	}
}
